import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const maxScroll = 400;
      const progress = Math.min((scrollPosition / maxScroll) * 100, 100);
      setScrollProgress(progress);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with subtle gradient */}
      <div 
        className="absolute inset-0 bg-gradient-to-b from-black via-gray-900 to-black"
        style={{
          opacity: 1 - scrollProgress * 0.005
        }}
      />

      {/* Stellar effect */}
      <div className="absolute inset-0">
        <div className="stars absolute inset-0" />
      </div>

      {/* Eclipse effect */}
      <div className="relative z-10 flex items-center justify-center">
        <motion.div 
          className="absolute w-64 h-64 rounded-full bg-white"
          style={{
            filter: `blur(${2 + scrollProgress * 0.1}px)`,
            boxShadow: `0 0 ${50 + scrollProgress}px ${20 + scrollProgress * 0.5}px rgba(255, 255, 255, 0.8)`
          }}
        />
        <motion.div 
          className="absolute w-64 h-64 rounded-full bg-black"
          style={{
            y: -scrollProgress,
            boxShadow: 'inset -25px -25px 40px rgba(255, 255, 255, 0.1)'
          }}
        />
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 text-center relative z-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2 }}
          className="space-y-6"
        >
          <h1 className="text-5xl md:text-7xl font-bold text-white tracking-tight">
            Robinson N.
            <br />
            <span className="bg-gradient-to-r from-blue-500 to-purple-500 text-transparent bg-clip-text">
              Marcano González
            </span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-300 max-w-2xl mx-auto">
            Higher Technician in Computer Network Systems Management
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mt-8">
            <a 
              href="europass.pdf" 
              download
              className="px-8 py-3 rounded-lg bg-white text-black hover:bg-gray-200 transition-colors w-full md:w-auto text-center"
            >
              Download Europass
            </a>
            <a 
              href="eurosupp.pdf" 
              download
              className="px-8 py-3 rounded-lg border-2 border-white text-white hover:bg-white/10 transition-colors w-full md:w-auto text-center"
            >
              EU Supplement
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 1.5, repeat: Infinity }}
      >
        <div className="w-6 h-10 rounded-full border-2 border-white p-1">
          <div className="w-1 h-2 bg-white rounded-full mx-auto animate-bounce" />
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;